let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lisF5")).then(() => parcelRequire('6vSsu'));